import { action } from 'typesafe-actions';
import { TicketInfoModel } from '../../common/models';
import { TicketInfoActionTypes } from './types';

export const showTicketInfoModal = () => action(TicketInfoActionTypes.SHOW_TICKETINFO_MODAL);

export const updateTicketInfo = (payload: TicketInfoModel) =>
  action(TicketInfoActionTypes.UPDATE_TICKETINFO, payload);
